<template>
  <HpFormControlWrapper
    :id="getId()"
    :rules="rules"
    :label="label"
    :name="name"
    :value="value"
    validation-mode="aggressive"
    :suppress-error-messages="suppressErrorMessages"
    v-slot="{ validationState, handleChange, handleBlur }"
    ref="wrapper"
  >
    <BaseFormRadioGroup
      v-model="value"
      :options="options"
      :text-field="textField"
      :value-field="valueField"
      :boxed="boxed"
      :button="button"
      :button-flex="buttonFlex"
      :buttonCompact="buttonCompact"
      :buttonCompactWrapped="buttonCompactWrapped"
      :icons="icons"
      :disabled="disabled"
      :readonly="readonly"
      :state="validationState"
      @change="handleChange"
      @blur="handleBlur"
      @click="$emit('click')"
    >
      <template #default>
        <slot></slot>
      </template>
      <template #first>
        <slot name="first"></slot>
      </template>
      <template #option="{ option, icon, checked }">
        <slot name="option" v-bind="{option, icon, checked }">

        </slot>
      </template>
    </BaseFormRadioGroup>
  </HpFormControlWrapper>
</template>

<script lang="ts" setup>
  import HpFormControlWrapper from './HpFormControlWrapper.vue'

  const props = defineProps({
    ...Id.props,
    ...ValidationProvider.props,
    ...FormControl.props,
    ...FormOptions.props,
    modelValue: {
      default: null
    },
    boxed: {
      type: Boolean,
      default: false
    },
    button: {
      type: Boolean,
      default: false
    },
    buttonFlex: {
      type: Boolean,
      default: false
    },
    buttonCompact: {
      type: Boolean,
      default: false
    },
    buttonCompactWrapped: {
      type: Boolean,
      default: false
    },
    icons: {
      type: Array,
      default: () => []
    }
  })

  const emit = defineEmits(['update:modelValue', 'change', 'click'])
  const value = VModel.use(props, emit)
  const { getId } = Id.use(toRef(props, 'id'))

  const wrapper = ref<InstanceType<typeof HpFormControlWrapper> | null>(null)
  const setErrors = (message: string | string[]) => wrapper?.setErrors(message)

  defineExpose({
    setErrors
  })
</script>

<style scoped></style>
